<template>
  <div class="orderDetails">
    <el-form ref="form">
      <el-row class="tit">
        <el-col :span="24">订单基础信息</el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>订单号</span>
          </label>{{form.orderId}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>订单状态</span>
          </label>{{form.payStatus == 1?'已支付':form.payStatus == 2?'待支付':'--'}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>下单时间</span>
          </label>{{form.createTime}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>门店</span>
          </label>{{form.shopName}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>订单类型</span>
          </label>{{form.orderType == 1?'线上订单':form.orderType == 2 ?'门店订单':'--'}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>订单金额</span>
          </label>
          {{form.orderType == 1 ? '￥'+(form.paidInAmount?form.paidInAmount.toFixed(2):'0.00'):'￥'+(form.amountReceivable?form.amountReceivable.toFixed(2):'0.00')}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>下单渠道</span>
          </label>{{form.buyChannelCode === 'store'?'门店':(form.buyChannelCode === 'app'?'APP':(form.buyChannelCode === 'wechatmini'?'微信小程序':'--'))}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>会员手机</span>
          </label>{{form.memberTelephone}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>会员姓名</span>
          </label>{{form.memberName | filterRow}}
        </el-col>
      </el-row>
      <el-row class="tit">
        <el-col :span="24">支付信息</el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>应付金额</span>
          </label>{{form.orderType == 1 ? '￥'+form.paidInAmount.toFixed(2):'￥'+(form.amountReceivable?form.amountReceivable.toFixed(2):'0.00')}}
        </el-col>
        <!-- <el-col :span="7">
          <label>
            <span>支付方式</span>
          </label>
          <div class="payTypes">{{form.orderType == 2?payType:(form.payDetails?(form.payDetails.payType == 'AliPay'?'支付宝':(form.payDetails.payType == 'WeChatPay'?'微信':'--')):'--')}}</div>
        </el-col> -->
        <el-col :span="7">
          <label>
            <span>实付金额</span>
          </label>{{form.paidInAmount?'￥'+(form.paidInAmount-form.giveChange).toFixed(2):'--'}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>优惠金额</span>
          </label>{{'￥'+((form.cutSmallChange?form.cutSmallChange:0) + (form.discount?form.discount:0)).toFixed(2)}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>现金</span>
          </label>{{'￥'+Number(form.cash).toFixed(2)}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>银行卡</span>
          </label>{{'￥'+Number(form.bankMoney).toFixed(2)}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>支付宝</span>
          </label>{{'￥'+Number(form.alipayMoney).toFixed(2)}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>微信</span>
          </label>{{'￥'+Number(form.wechatpayMoney).toFixed(2)}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>充值账户</span>
          </label>{{'￥'+Number(form.rechargeAccountMoney).toFixed(2)}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>赠送账户</span>
          </label>{{'￥'+Number(form.giftAccountMoney).toFixed(2)}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>返现账户</span>
          </label>{{'￥'+Number(form.returnMoney).toFixed(2)}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>折扣</span>
          </label>{{'￥'+Number(form.discount).toFixed(2)}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>抹零</span>
          </label>{{'￥'+Number(form.cutSmallChange).toFixed(2)}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>找零</span>
          </label>{{'￥'+Number(form.giveChange).toFixed(2)}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>支付流水</span>
          </label>{{form.payDetails?form.payDetails.serialNo:'--'}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>交易流水</span>
          </label>{{form.payDetails?form.payDetails.thirdSerialNo:'--'}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>支付时间</span>
          </label>{{form.orderType == 2?form.createTime:form.payTime | filterRow}}
        </el-col>
      </el-row>
      <el-row class="tit">
        <el-col :span="24">商品信息</el-col>
      </el-row>
      <el-row v-for="(i,index) in form.orderGoodsList" :key="index">
        <el-row>
          <el-col :span="1">
            <div class="seize"></div>
          </el-col>
          <el-col :span="7">
            <label>
              <span>售卖编号</span>
            </label>{{i.goodsId}}
          </el-col>
          <el-col :span="7">
            <label>
              <span>商品名称</span>
            </label>{{i.goodsName}}
          </el-col>
          <el-col :span="7">
            <label>
              <span>商品标题</span>
            </label>{{i.goodsTitle | filterRow}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="1">
            <div class="seize"></div>
          </el-col>
          <el-col :span="7">
            <label>
              <span>类型</span>
            </label><span v-if="i.goodsType == 1">{{i.addType | filterAddType}}</span><span v-else>零售商品</span>
          </el-col>
          <el-col :span="7">
            <label>
              <span>销售数量</span>
            </label>{{i.saleNumber}}
          </el-col>
        </el-row>
        <el-row v-if="i.goodsType == 1">
          <el-col :span="1">
            <div class="seize"></div>
          </el-col>
          <el-col :span="19">
            <el-table
              v-if="i.orderGoodsDetailsList.length > 0 && i.addType != 19"
              :data="i.orderGoodsDetailsList"
              border
              @cell-click="linkTo"
              :cell-style="{height:'42px'}"
              style="width: 100%"
              :header-cell-style="{background:'#EFF1F5',height:'47px'}"
            >
              <el-table-column align="center" prop="goodsName" label="服务项目">
                <template slot-scope="scope">
                  <el-row class="tableGoods">
                    <el-popover trigger="hover" placement="top">
                      {{scope.row.goodsName}}
                      <el-col slot="reference" class="myTitle">
                        <span>{{scope.row.goodsName}}</span>
                      </el-col>
                    </el-popover>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="containFrequency" label="购买次数">
                <template slot-scope="scope">{{scope.row.courseStyle == 1?scope.row.containFrequency:(scope.row.courseStyle == 2 ? scope.row.addDate+'个月':scope.row.addDate+'个月 ' + scope.row.containFrequency+'次') | filterRow}}</template>
              </el-table-column>
              <el-table-column align="center" prop="residueFrequency" label="剩余次数">
                <template slot-scope="scope">
                  <span v-if="scope.row.courseStyle == 1">{{scope.row.residueFrequency >= 0?scope.row.residueFrequency:(scope.row.residueFrequency | filterRow)}}</span>
                  <span v-if="scope.row.courseStyle == 2">{{scope.row.serviceEndDate | filterRow}}</span>
                  <span v-if="scope.row.courseStyle == 3">{{(scope.row.serviceEndDate+scope.row.residueFrequency+'次') | filterRow}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="isReturn" label="状态">
                <template slot-scope="scope">{{scope.row.isReturn == 1?'已退货':'正常' | filterRow}}</template>
              </el-table-column>
              <!-- <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <span v-if="scope.row.isReturn == 1">--</span>
                  <el-button size="mini" class="delete" @click="refund(scope.row)" v-else>退货</el-button>
                </template>
              </el-table-column> -->
              <el-table-column align="center" prop="goodsReturnId" label="关联退货单">
                <template slot-scope="scope">{{scope.row.goodsReturnId | filterRow}}</template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-row>
      <!-- <el-row class="tit">
        <el-col :span="24">服务单信息</el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="23">
          <el-table
            :data="form.serviceSub"
            border
            @cell-click="linkTo"
            :cell-style="{height:'42px'}"
            style="width: 100%"
            :header-cell-style="{background:'#EFF1F5',height:'47px'}"
          >
            <el-table-column align="center" prop="serviceId" label="服务单号">
              <template slot-scope="scope">{{scope.row.serviceId | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="price" label="服务开始时间">
              <template slot-scope="scope">{{scope.row.serviceName | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="price" label="服务结束时间">
              <template slot-scope="scope">{{scope.row.serviceName | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="price" label="服务调理师">
              <template slot-scope="scope">{{scope.row.serviceName | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="floorPrice" label="服务项目">
              <template slot-scope="scope">{{scope.row.serviceName | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="relation" label="是否预约">
              <template slot-scope="scope">{{scope.row.relation | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="relation" label="是否上门">
              <template slot-scope="scope">{{scope.row.relation | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="relation" label="创建时间">
              <template slot-scope="scope">{{scope.row.relation | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="relation" label="服务单状态">
              <template slot-scope="scope">{{scope.row.relation | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="relation" label="调理小结">
              <template slot-scope="scope">{{scope.row.relation | filterRow}}</template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="23">
          <div class="btnOptions">
            <el-button class="darkBtn" @click="closeTab">关闭</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog title="退货单" :visible.sync="dialogTableVisible" :center="true" width="580px">
      <!-- 退货 -->
      <refused :actualPaid="actualPaid" :physicalFlag='curRowData' :relationFlag='relationFlag' @closeDialog="closeDialog" />
    </el-dialog>
    <el-dialog title="服务单详情" :visible.sync="dialogDetailVisible" :center="true" width="580px">
      <!-- 服务单详情 -->
      <serviceDetail @closeDialog="closeDialog" />
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import { saleOrderInfo, getOrderGoodsReturnByGoodsDetailsId } from "@/api";
import refused from "./refused";
import serviceDetail from "./serviceDetail";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  components: {
    refused,serviceDetail
  },
  data() {
    return {
      actualPaid:200,
      form: {
        serviceRevise: {},
        payDetails:{}
      },
      dialogVisible: false,
      dialogImageUrl: "",
      fileListData: [],
      fileLength: 0,
      dialogTableVisible:false,//退货弹框
      dialogDetailVisible:false,//服务单详情弹窗
      relationFlag:false,//退货单
      curRowData:[],
    };
  },
  created() {
    this.detailInfo();
  },
  watch: {
    '$route.params.orderid'(val){
      if(val){
        this.detailInfo();
      }
    }
  },
  computed: {
    payType(){
      let total=[],money='';
      if(this.form.cash && this.form.cash>0){
        total.push('现金')
      }
      if(this.form.bankMoney && this.form.bankMoney>0){
        total.push('银行卡')
      }
      if(this.form.alipayMoney && this.form.alipayMoney>0){
        total.push('支付宝')
      }
      if(this.form.wechatpayMoney && this.form.wechatpayMoney>0){
        total.push('微信')
      }
      if(this.form.rechargeAccountMoney && this.form.rechargeAccountMoney>0){
        total.push('充值账户')
      }
      if(this.form.giftAccountMoney && this.form.giftAccountMoney>0){
        total.push('赠送账户')
      }
      if(this.form.returnMoney && this.form.returnMoney>0){
        total.push('返现账户')
      }
      total.forEach((item,index)=>{
        money += item +((index == total.length - 1)? '': '，')
      })
      return money;
    }
  },
  methods: {
    detailInfo() {
      if(this.$route.params.orderid){
        saleOrderInfo({
          orderId: this.$route.params.orderid
        }).then(res => {
          if (res.code == 1) {
            this.form = res.data;
            this.form.orderGoodsList.forEach((m,index) =>{
              m.orderGoodsDetailsList.forEach((n,detail)=>{
                if(n.isReturn == 1){
                  getOrderGoodsReturnByGoodsDetailsId({
                    goodsDetailsId:n.id
                  }).then( returns =>{
                    this.$set(this.form.orderGoodsList[index].orderGoodsDetailsList[detail],'goodsReturnId',returns.data.goodsReturnId)
                  })
                }
              })
            })
          }
        });
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    refund(row){
      // 退货
      // this.dialogTableVisible = true;
      // this.relationFlag = false;
      // this.curRowData = row;
      this.$confirm( '此功能暂未开放！请等待...', "提示", {
          showCancelButton: false,
          type: "warning"
      })
    },
    linkTo(row, column){
      // 退货单
      if(column.property == 'relation'){
        if(row.relation){
          // this.relationFlag = true;
          // this.dialogTableVisible = true;
          // this.curRowData = row;
          this.$confirm( '此功能暂未开放！请等待...', "提示", {
              showCancelButton: false,
              type: "warning"
          })
        }
      }else if(column.property == 'serviceId'){
        this.dialogDetailVisible = true;
      }
    },
    closeTab() {
      // 关闭当前tab
      this.$store.commit("delete_tabs", this.$route.path);
      this.$router.push("/financeManageCenter/order");
    },
    closeDialog(val){
      this.dialogTableVisible = val;
      this.dialogDetailVisible = val;
    },
  }
};
</script>
<style lang="less" scoped>
.orderDetails {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
  padding: 80px 0 60px;
  position: relative;
  .el-row.tit {
    color: #444;
    margin-bottom: 30px;
  }
  .el-row {
    margin-bottom: 15px;
    .point {
      color: #f83b56;
      font-size: 17px;
      font-weight: bold;
    }
    .myTxt {
      padding-left: 105px;
      margin-top: -30px;
    }
  }
  label {
    width: auto;
    text-align: right;
    display: inline-block;
    margin-right: 10px;
    span {
      min-width: 95px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      padding: 0 15px;
      background: #eff1f5;
      border-radius: 15px;
      color: #444;
    }
  }
  .payTypes{
    padding-left: 105px;
    margin-top: -26px;
  }
  .seize {
    height: 20px;
  }
}
</style>
<style lang="less">
.orderDetails {
  .el-table td,
  .el-table th {
    padding: 0;
  }
  .btnOptions {
    text-align: center;
    margin: 0;
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
  .el-dialog__title{
    font-weight:bold
  }
  .tableGoods {
    &.el-row {
      margin-bottom: 0;
    }
    .myTitle {
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .delete {
    color: #f83b56;
    border: 1px solid #f83b56;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/orderDetail.vue